import React from 'react'
import cx from 'classnames'
import { formLoginNamesConvertor } from '../../services/formNamesConvertor'
import PropTypes from 'prop-types'

import styles from './FormItemWithValidation.module.scss'

const FormItemWithValidation = ({ validationError, children, itemName }) => {
	const convertedName = formLoginNamesConvertor(itemName)

	return (
		<div className={styles.container}>
			<p
				className={cx(styles.fieldLabel, {
					[styles.fieldError]: validationError.includes(itemName)
				})}
			>
				{convertedName}
			</p>
			{children}
			<p
				className={cx(styles.errorLabel, {
					'd-block': validationError.includes(itemName)
				})}
			>
				Please, write {convertedName}
			</p>
		</div>
	)
}

FormItemWithValidation.propTypes = {
	validationError: PropTypes.array,
	children: PropTypes.object,
	itemName: PropTypes.string
}
FormItemWithValidation.dafaultProps = {
	validationError: [],
	children: null,
	itemName: ''
}

export default FormItemWithValidation
